import type React from 'react';

import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';

import type { WorkflowStep } from '../../types';

type FinishStepContentProps = {
  step: WorkflowStep;
};

export const FinishStepContent: React.FC<FinishStepContentProps> = ({ step }) => <Text textType={TextType.Label} value={step.title} />;
